import { useCitationNumbering } from '../../../components';
import type { NumberedLink } from '../../../utils/markdownLinks';

import { citedStatisticLinks, statisticIdOf } from './statistaCitations';

/**
 * The citation badge the prose already shows for a dataset, so a chart carries the
 * same number as the sentence citing it.
 *
 * Reads the number rather than registering: the registry hands numbers out in render
 * order, and this runs before the block's own `AnalysisMarkdown` children. Registering
 * here would let a chart claim the number belonging to prose the reader meets first.
 * A chart whose citation has not been numbered yet simply shows no badge.
 */
export const useCitationForDataset = (
  passage: unknown,
  deepLink: string | null,
): NumberedLink | undefined => {
  const { numberFor } = useCitationNumbering();

  const wanted = statisticIdOf(deepLink);
  if (!wanted) return undefined;

  const cited = citedStatisticLinks(passage).find((link) => statisticIdOf(link.url) === wanted);
  if (!cited) return undefined;

  const number = numberFor(cited.url);
  return number === undefined ? undefined : { ...cited, number };
};
